module.exports = __webpack_public_path__ + "static/media/kurt.aa4ff12f.jpg";